module.exports = __webpack_public_path__ + "img/positive_2.0813890b.png";